export default "__VITE_PUBLIC_ASSET__23b48180__"